import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import CategoryNavbar from "../AdminComp/CategoryNavbar";
import Swal from "sweetalert2";

const InstrumentType = () => {
  const [menus, setMenus] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [subSubSubCategories, setSubSubSubCategories] = useState([]);
  const [finalCategories, setFinalCategories] = useState([]);

  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
  const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState("");
  const [selectedFinalCategory, setSelectedFinalCategory] = useState("");

  const [title, setTitle] = useState("");
  const [position, setPosition] = useState(0);
  const [isCategory, setIsCategory] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (title.length > 0) {
      fetchSuggestions(title);
    } else {
      setSuggestions([]); // Clear dropdown when input is empty
    }
  }, [title, selectedMainCategory]); // Added selectedMainCategory as a dependency
  

  const fetchSuggestions = async (categoryId) => {
    try {
      if (!categoryId) {
        console.warn("Skipping fetch: No category selected.");
        return;
      }
  
      console.log("Fetching suggestions with:", { category_id: categoryId });
  
      const response = await axios.get(`${baseurl}getMenuSuggestions?category_id=${categoryId}`);
  
      console.log("API Response:", response.data);
  
      setSuggestions(response.data || []);
    } catch (error) {
      setSuggestions([]);
      console.error("Error fetching suggestions:", error);
    }
  };
  
  const handleSelectCategory = (category) => {
    setSuggestions([]);  
  };
  
  
  useEffect(() => {
    if (selectedMainCategory) {
      fetchSuggestions(selectedMainCategory);
    } else {
      setSuggestions([]);
    }
  }, [selectedMainCategory]);
  


  
  const [titles, setTitles] = useState([""]); // Initialize with one empty title

  const handleAddTitle = () => {
    setTitles([...titles, ""]); // Add a new empty title
  };
  
  const handleRemoveTitle = (index) => {
    const newTitles = titles.filter((_, i) => i !== index); // Remove the title at the specified index
    setTitles(newTitles);
  };
  
  const handleTitleChange = (index, newTitle) => {
    const newTitles = [...titles];
    newTitles[index] = newTitle; // Update the specific title
    setTitles(newTitles);
  }; 
  // Fetch Menus
  useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        setMenus(response.data);
        setMainCategories(response.data.filter(menu => menu.parent_id === null));
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  // Handle dropdown changes
  const handleMainCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedMainCategory(selectedId);
    setSubCategories(menus.filter(menu => menu.parent_id === selectedId));
    setSelectedSubCategory("");
    setSubSubCategories([]);
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");

     // Only call API if a valid category is selected
     if (selectedId) {
      fetchSuggestions(selectedId);
    } else {
      setSuggestions([]); // Clear suggestions if category is empty
    }



  };

  const handleSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubCategory(selectedId);
    setSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");

     // Only call API if a valid category is selected
     if (selectedId) {
      fetchSuggestions(selectedId);
    } else {
      setSuggestions([]); // Clear suggestions if category is empty
    }



  };

  const handleSubSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubSubCategory(selectedId);
    setSubSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");

     // Only call API if a valid category is selected
     if (selectedId) {
      fetchSuggestions(selectedId);
    } else {
      setSuggestions([]); // Clear suggestions if category is empty
    }

  };

 
  // Handle Image Upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("titles", JSON.stringify(titles));
      formData.append(
        "parent_id",
        selectedFinalCategory ||
          selectedSubSubSubCategory ||
          selectedSubSubCategory ||
          selectedSubCategory ||
          selectedMainCategory ||
          null
      );
      formData.append("position", parseInt(position));
      formData.append("is_category", isCategory);
      if (image) formData.append("image", image);
  
      console.log("Sending Form Data:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
  
      const response = await axios.post(`${baseurl}addMenuWithImageForinstrument`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      console.log("Server Response:", response.data);
  
      // Show success message
      Swal.fire({
        title: "Success!",
        text: "Menu item added successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.reload(); // Reload page on OK
      });
  
      // Refresh Menus
      axios.get(`${baseurl}getMenus`).then((response) => {
        setMenus(response.data);
        setMainCategories(response.data.filter((menu) => menu.parent_id === null));
      });
  
      // Reset Form
      setTitle("");
      setSelectedMainCategory("");
      setSelectedSubCategory("");
      setSelectedSubSubCategory("");
      setSelectedSubSubSubCategory("");
      setSelectedFinalCategory("");
      setPosition(0);
      setIsCategory(false);
      setImage(null);
      setPreview(null);
    } catch (error) {
      console.error("Error adding menu:", error);
  
      // Handle duplicate record error
       if (
        error.response?.status === 400 &&
        (error.response.data.message === "No new titles were inserted (all were duplicates)" ||
          error.response.data.message === 'Duplicate title found')
      ) {
        Swal.fire({
          title: "Duplicate Record!",
          text: "A menu item with this title already exists.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }else {
        // Show generic error alert
        Swal.fire({
          title: "Error!",
          text: "Failed to add menu item. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };
  
  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <CategoryNavbar />
          <div className="crd1">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h4 className="text-start">Add Make/Brand</h4>
            </div>

            <form onSubmit={handleSubmit} className="row g-2 text-start">
              {/* Main Category */}
              <div className="col-md-8">
                <label className="form-label">What we do</label>
                <select className="form-select" value={selectedMainCategory} onChange={handleMainCategoryChange}>
                  <option value="">Select Here</option>
                  {mainCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                </select>
              </div>
              {/* Other dropdowns (Sub Categories) */}
              {/* {subCategories.length > 0 && ( */}
                <div className="col-md-8">
                  <label className="form-label">Select Category</label>
                  <select className="form-select" value={selectedSubCategory} onChange={handleSubCategoryChange}>
                    <option value="">Select Here</option>
                    {subCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                  </select>
                </div>
              {/* )} */}
 {/* Sub-Sub Category */}
      {/* {subSubCategories.length > 0 && ( */}
        <div className="col-md-8">
          <label className="form-label">Type of Instrument</label>
          <select className="form-select" value={selectedSubSubCategory} onChange={handleSubSubCategoryChange}>
            <option value="">Select Here</option>
            {subSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      {/* )} */}
      {/* Title */}
{/* Title Rows with Suggestions */}
{titles.map((title, index) => (
  <div key={index} className="col-md-8 mb-2">
    <label className="form-label">Enter Make/Brand</label>
    <input
      type="text"
      className="form-control"
      placeholder="Eg. Business & Industrial"
      value={title}
      onChange={(e) => handleTitleChange(index, e.target.value)}
      required
    />
    {/* Suggestions Dropdown */}
    {suggestions.length > 0 && (
      <ul className="list-group">
        {suggestions.map((category, idx) => (
          <li
            key={idx}
            className="list-group-item list-group-item-action listcls"
            onClick={() => handleSelectCategory(index, category.title)}
            style={{ cursor: "pointer" }}
          >
            {idx + 1}. {category.title}  
            {category.status === "active" ? (
              <span className="text-success"> &nbsp;:[Active Category]</span>
            ) : category.status === "inactive" ? (
              <span className="text-danger"> &nbsp;:[Inactive/Trash Category]</span>
            ) : (
              <small className="text-danger"> &nbsp;:[Already Exists]</small>
            )}
          </li>
        ))}
      </ul>
    )}
    {/* Remove button for each row */}
    {index > 0 && (
      <div className="text-end">
        <button
        type="button"
        className="btn btn-danger mt-2"
        onClick={() => handleRemoveTitle(index)}
      >
        Remove
      </button>
      </div>
      
    )}
  </div>
))}

{/* Add Title Button */}
<div className="col-md-8">
  <button type="button" className="btn btn-primary" onClick={handleAddTitle}>
    Add Title
  </button>
</div>


              {/* Image Upload */}
              <div className="col-md-8">
                <label className="form-label">Upload Image</label>
                <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
                {preview && <img src={preview} alt="Preview" className="img-thumbnail mt-2" style={{ width: "100px", height: "100px" }} />}
              </div>

              <div className="col-12 text-end">
                <button type="submit" className="btn submitbtnn">Add Menu</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InstrumentType;
